import './scorm'
import { 
  scormplayerhtml,
  ispringsummaryhtml,
  ispringnavhtml
} from './templates'
import startcourse from './startcourse'

(function($) { 

  let $academyscorm = $('.wp-block-academy-scorm') 
  if(
    $academyscorm.length
    // && 
    // window.academystatus.userlogged
  ) {

    $academyscorm = $academyscorm.eq(0)

  } else {

    return
  } 

  const data = $academyscorm.data()
  const $scorm = $academyscorm.find('.Scorm')
  const $scormplayer = $academyscorm.find('div.ScormPlayer')
  const $start = $('.ShortCode.CourseFeatures .Start')
  const $certificate = $('.ShortCode.CourseFeatures .Certificate')
  const $startbutton = $start.find('a')

  $scorm.html($startbutton.html())
  
  $scormplayer.append(scormplayerhtml)

  if(data.withspringnav) {

    const $coverimage = $('.wp-post-image').eq(0).clone()

    $scormplayer.prepend(ispringsummaryhtml)  

    const $ispringsummarycover = $scormplayer.find('.Cover')
    $ispringsummarycover.append($coverimage)    

    const $player = $scormplayer.find('.Player')    

    const coursetitle = $('h1.entry-title').html() 

    $player.append(ispringnavhtml(coursetitle))

    const $ispringsummary = $scormplayer.find('.ISpringSummary')

    const $navtoggle = $player.find('.NavToggle .Hamburguer')
    $navtoggle.on(
      'click',
      function() {

        $ispringsummary.toggleClass('Visible')
      }
    )
  } 

  const $closeplayer = $scormplayer.find('.ClosePlayer')
  $closeplayer.on(
    'click',
    function() {

      $scormplayer.dialog('close')

      location.reload()
    }
  )

  const showbuttons = () => {

    $scorm.on(
      'click',
      window.academyStartCourse
    ) 

    $start.on(
      'click',
      window.academyStartCourse
    )

    $start.show()
    $scorm.addClass('Visible')  
    $certificate.show()
  } 
  
  showbuttons()

  /*
  window.academyStartCourse()
  */
  
})(jQuery)